export default __webpack_public_path__ + "static/media/031-graphic tablet.e56e6053.svg";